import * as Sentry from '@sentry/vue';
import { HttpClient } from '@sentry/integrations';
import { version } from '@root/package.json'; // eslint-disable-line
import router from '@/router'; // eslint-disable-line

export default ({ Vue }) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: `cxm-app@${version}`,
    sendDefaultPii: true,

    ignoreErrors: [
      'Cannot read properties of null (reading \'setAttribute\')',
      /node_modules/,
      /axios/,
      // /Cannot read properties of null/,
    ], // Ignore Google Tag Manager errors

    beforeSend: (event) => {
      const ignoreError = event?.exception?.values
        .some((exc) => [400, 401, 403]
          .some((err) => exc?.value.indexOf(err) > 0));

      if (ignoreError) {
        return null;
      }

      return event;
    },

    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ['localhost', /^https:\/\/api.track\.co/],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new HttpClient(),
      new Sentry.Replay(),
    ],

    // Track Vue Components
    trackComponents: true,

    // Performance Monitoring
    tracesSampleRate: 0.1,

    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};

export const setSentryUser = ({
  email, name, uuid, organization,
}) => {
  Sentry.setUser({
    email,
    username: name,
    id: uuid,
    organization,
  });
};

const setSentryNewTag = (scope, tagName, tagValue) => {
  scope.setTag(tagName, tagValue);
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

const removeEmptyProperties = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => !!v));

export const setSentryTag = (tags, obj = {}) => {
  Sentry.configureScope((scope) => {
    let extras = obj;
    const profile = localStorage.getItem('t-profile');
    const organization = localStorage.getItem('t-org');

    if (profile) {
      const { email, name, uuid } = JSON.parse(profile);
      extras = {
        ...extras, userEmail: email, userName: name, userUuid: uuid,
      };
    }

    if (organization) {
      const { name: orgName, uuid: orgUuid } = JSON.parse(organization);
      extras = {
        ...extras, orgName, orgUuid,
      };
    }

    tags.forEach((tag) => {
      setSentryNewTag(scope, tag.tagName, tag.tagValue);
    });

    scope.setExtras(removeEmptyProperties(extras));
  });
};
